import { useTranslation } from "react-i18next";
import { AddQuestionTypeButtons } from "./AddQuestionTypeButtons";

export function FirstQuestionPlaceholder() {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col gap-5 p-2">
            <div className="flex flex-col gap-1">
                <h2 className="text-h3 text-compendia-foreground font-medium">
                    {t("question.firstQuestion.title")}
                </h2>
                <p className="text-text-secondary text-base font-light">
                    {t("question.firstQuestion.subtitle")}
                </p>
            </div>
            <div className="p-2 flex flex-col justify-center items-center">
                <AddQuestionTypeButtons />
            </div>
        </div>
    );
}
